// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mds-tbody_quvW6 {\n  background-color: inherit;\n}", "",{"version":3,"sources":["webpack://./node_modules/@mds/data-table/src/tbody.scss","webpack://./tbody.vue"],"names":[],"mappings":"AAAA;EACI,yBAAA;ACCJ","sourcesContent":[".mds-tbody {\n    background-color: inherit;\n}\n",".mds-tbody {\n  background-color: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mds-tbody": "mds-tbody_quvW6"
};
export default ___CSS_LOADER_EXPORT___;
